import { CurrencySetting, MatchedLine, Point } from "../../type";

export type AnimationPoint = {
  x: number;
  y: number;
  isIceBreak: boolean;
  isDropdownPoint: boolean;
  groupId: number;
  endId: number;
  win: number;
};

export type DearSenpaiGameData = {
  category: Categories;
  freeSpinMode: FreeSpinMode;
  animationGroup: {
    [K: number]: MatchedLine;
  };
  multiplier: number;
  scatterPoints: Point[];
};

export enum Categories {
  Normal = 0,
  BuyFreeSpin = 1,
}

export enum FreeSpinMode {
  None = 0,
  Male = 1,
  Female = 2,
}

export enum Symbols {
  Symbol1 = 201,
  Symbol2 = 202,
  Symbol3 = 203,
  Symbol4 = 204,
  Symbol5 = 205,
  Symbol6 = 206,
  Symbol7 = 207,
  Scatter = 25,
  Wild = 21,
}

export type Rule = {
  buyFreeSpinRate: number;
  payouts: { [k: string]: number };
  givenFreeSpin: { [k: string]: number };
};

export type Setting = {
  currencies: CurrencySetting[];
  payouts: { [k: string]: number };
  buyFreeSpinRate: number;
};
